import { Deserializable } from '../../interfaces/deserializable';

export class FileModel implements Deserializable {

	public fileHash: string = null;
	public deleted: boolean = null;
	public extracted: boolean = null;

	deserialize(input: any): this {
		Object.getOwnPropertyNames(this).forEach(property => {
			if (input[property] != null && input[property] != undefined) {
				this[property] = input[property];
			}
		});
		return this;
	}
}
